const addMultipleEventListener = (el, s, fn) => {
    s.split(' ').forEach((e) => el.addEventListener(e, fn, false))
}
const getPercentage = (partialValue, totalValue) => {
    return (100 * partialValue) / totalValue
}

export { addMultipleEventListener, getPercentage }
